import { DISTRIBUIDOR, FABRICANTE, IMPORTADOR, UJ } from 'utils/constants/reach_role';

import Joi from '@hapi/joi';

const baseProperties = ['code', 'trade_name', 'supplier_id', 'sds_date', 'sds_revision', 'reach_role'];

export const schema = data => {
  const joiObj = {
    code: Joi.string()
      .min(3)
      .max(60)
      .required()
      .messages({
        "any.required": `"Código" campo de preenchimento obrigatório`,
        "string.empty": `"Código" campo vazio`,
        "string.min": `"Código" tem de ter pelo menos 3 caracteres`,
        "string.max": `"Código" só pode 60 caracteres máximo`
      }),
    trade_name: Joi.string()
      .min(3)
      .max(200)
      .required()
      .messages({
        "any.required": `"Designação Comercial" campo de preenchimento obrigatório`,
        "string.empty": `"Designação Comercial" campo vazio`,
        "string.min": `"Designação Comercial" tem de ter pelo menos 3 caracteres`,
        "string.max": `"Designação Comercial" só pode 200 caracteres máximo`
      }),
    supplier_id: Joi.number()
      .required()
      .messages({
        "any.required": `"Fornecedor" campo de preenchimento obrigatório`,
        "number.base": `"Fornecedor tem de ser um identificador numérico"`
      }),

    sds_date: Joi.date()
      .allow(null)
      .messages({
        "any.required": `"Data FDS" campo de preenchimento obrigatório`,
        "date.base": `"Data FDS" tem de ser uma data válida"`
      }),
    sds_revision: Joi.string()
      .max(25)
      .allow('')
      .messages({
        "any.required": `"Revisão FDS" campo de preenchimento obrigatório`,
        "string.empty": `"Revisão FDS" campo vazio`,
        "string.max": `"Revisão FDS" só pode 25 caracteres máximo`
      }),
    reach_role: Joi.string()
      .valid(FABRICANTE, DISTRIBUIDOR, UJ, IMPORTADOR)
      .required()
      .messages({
        "any.required": `"Papel Reach" campo de preenchimento obrigatório`,
        "string.empty": `"Papel Reach" campo vazio`,
        "any.only": `"Papel Reach" só pode ter as seguintes opções:  Fabricante, Distribuidor, UJ, Importador`,
        "string.valid": `"Papel Reach" só pode ter as seguintes opções: Fabricante, Distribuidor, UJ, Importador`
      })
  };

  if (data.code && data.code !== '') {
    return Joi.object({
      code: Joi.string()
        .min(3)
        .max(60)
        .pattern(/^[a-zA-Z0-9\-_\s]+$/)
        .empty('')
        .required()
        .messages({
          "any.required": `"Código MP" campo de preenchimento obrigatório`,
          "string.empty": `"Código MP" campo vazio`,
          "string.min": `"Código MP" tem de ter pelo menos 3 caracteres`,
          "string.max": `"Código MP" só pode 60 caracteres máximo`,
          "string.pattern.base": `"Código MP" só pode usar caracteres alfanuméricos e "-_ "`
        }),
      ...joiObj
    });
  } else {
    return Joi.object(joiObj);
  }
};


export const validator = (newEntity, shipments) => {
  let error = undefined;
  let iEntity = { ...newEntity };

  if (newEntity.code && newEntity.code !== '') {
    baseProperties.push('code');
  }
  Object.keys(iEntity).forEach(k => {
    if (!baseProperties.includes(k)) {
      delete iEntity[k];
    }
  });
  // Validate data correctness
  const validateEntity = schema(newEntity).validate(iEntity, { abortEarly: false });
  if (validateEntity.error) {
    return { error: validateEntity.error.details.map(obj => obj.message) };
  }
  return error ? error : iEntity;
};

